import { cn } from "@/lib/utils";

// The donor's `CustomBadge` (`timmy/src/components/custom-badge/custom-badge.tsx:3-36`),
// an app-level donor component: the Vis Spec review draws it after a line's
// name as "Paid Upgrade" (`select-options-table.tsx:119-121`, `color='warning'`),
// and two spec screens outside the communities node draw its green default.
//
// Value for value: a react-ui `Typography component='span'` at `body1` — weight
// 400 over a 1.5 line — restyled by `sx` to `display: inline-flex`, `width:
// fit-content`, `padding: 0 0.5rem`, `font-size: 0.8rem` and `border-radius:
// 1rem`, in one of two literal paints (the `badge-*` tokens). No border, no role.

const PAINT = {
  success: "text-lennar-success bg-badge-success-ground",
  warning: "text-badge-warning-ink bg-badge-warning-ground",
} as const;

export interface CustomBadgeProps {
  /** The pill's words. Empty by default, as the donor's `text = ''`. */
  text?: string;
  /** `success` by default, as the donor's. */
  color?: keyof typeof PAINT;
  className?: string;
  "data-testid"?: string;
}

export function CustomBadge({
  text = "",
  color = "success",
  className,
  "data-testid": testId = "custom-badge",
}: CustomBadgeProps) {
  return (
    <span
      data-testid={testId}
      className={cn(
        "inline-flex w-fit rounded-[1rem] px-2 text-[0.8rem] leading-[1.5] font-normal",
        PAINT[color],
        className,
      )}
    >
      {text}
    </span>
  );
}
